export const FAIL_OPERATION = 'FAIL_OPERATION';
export default function failOperation(id) {
  return {
    type: FAIL_OPERATION,
    id,
  };
}
